import { Mapper } from 'src/base/mapper'
import { CheckDuplicateItemCodeTypeEntity } from 'src/data/entities/product-item.entity'
import { CheckDuplicateItemCodeTypeModel } from 'src/domain/models/product-item.model'

export class CheckDuplicateItemCodeMapper extends Mapper<
	CheckDuplicateItemCodeTypeEntity,
	CheckDuplicateItemCodeTypeModel
> {
	mapFrom(param: CheckDuplicateItemCodeTypeEntity): CheckDuplicateItemCodeTypeModel {
		return this.resultData(param)
	}

	mapTo(param: CheckDuplicateItemCodeTypeModel): CheckDuplicateItemCodeTypeEntity {
		return this.resultData(param)
	}

	resultData(param: CheckDuplicateItemCodeTypeEntity | CheckDuplicateItemCodeTypeModel) {
		return {
			data: param.data,
			status: param.status,
		}
	}
}
